import { Link, Inserter, SessionRole, SessionLogout, useLanguage } from "nystem-components";
import React from "react";
import app from "nystem";

const PartAdmin = () => {
  const lang = useLanguage();

  return (
    <div>
      <SessionRole userrole="super config" className="admin container max-w-3xl">
        <Inserter match="/admin*" className="admin-container container p-3">
          <div>
            <h1 className="pl-0!">Admin</h1>
            <div className="mb-8 flex items-center gap-1 border-b border-gray-200 pb-3 text-base">
              <Link
                className="rounded px-3 py-2 hover:bg-gray-100 [&.active]:bg-gray-200 [&.active]:font-semibold"
                to="/admin"
                match={["/admin", "/admin/page*"]}
              >
                {app.t("Pages")}
              </Link>
              <Link
                className="rounded px-3 py-2 hover:bg-gray-100 [&.active]:bg-gray-200 [&.active]:font-semibold"
                to="/admin/language/list"
                match="/admin/language*"
              >
                {app.t("Languages")}
              </Link>
              <SessionRole userrole="super">
                <Link
                  className="rounded px-3 py-2 hover:bg-gray-100 [&.active]:bg-gray-200 [&.active]:font-semibold"
                  to="/admin/user/list"
                  match="/admin/user*"
                >
                  {app.t("Users")}
                </Link>
              </SessionRole>
              <SessionLogout
                type="button"
                className="ml-auto rounded border border-gray-300 bg-gray-200 py-2 px-4 text-base text-gray-900 shadow-sm hover:bg-gray-300"
                to="/admin"
              >
                {app.t("Log out")}
              </SessionLogout>
            </div>
          </div>
          <div>
            <Inserter key={lang} match="/admin" source="/page/list" />
            <Inserter match="/admin/page*" source="/page*" />
            <Inserter match="/admin/language*" source="/language*" />
            <Inserter match="/admin/user*" source="/user*" />
          </div>
        </Inserter>
      </SessionRole>
      <SessionRole userrole="logged-out user">
        <Inserter
          className="blog container"
          source="/user/login"
          match="/admin*"
        />
      </SessionRole>
    </div>
  );
};
export default PartAdmin;
